import { cn, Icon } from "@cca/components";

type OverallFeedbackPreviewProps = {
  expanded: boolean;
  feedbackHtml: string;
  onToggle: () => void;
};

export const OverallFeedbackPreview = ({
  expanded,
  feedbackHtml,
  onToggle,
}: OverallFeedbackPreviewProps) => (
  <div className="cursor-pointer border-b border-gray-100" onClick={onToggle}>
    <div
      className={cn(
        "flex w-full flex-row items-center justify-between px-4 text-sm",
        expanded ? "mt-4 h-8" : "h-16",
      )}
    >
      <div className="flex h-8 w-full flex-row items-center justify-between">
        <span className="text-xs font-semibold text-neutral-600 uppercase">
          Overall feedback
        </span>
        <Icon
          className="h-4 w-4 transform transition-transform duration-200"
          type={expanded ? "chevron-down" : "chevron-up"}
        />
      </div>
    </div>

    {expanded && (
      <div
        className="max-h-36 overflow-scroll px-4 py-2 text-base text-gray-950"
        dangerouslySetInnerHTML={{ __html: feedbackHtml }}
      />
    )}
  </div>
);
